<h2 mat-dialog-title>{{data.heading}}</h2>

<mat-dialog-actions>
  <button type="button" color="primary" mat-raised-button (click)="closeDialog()">
    <fa-icon icon="window-close"></fa-icon>&nbsp;&nbsp;Close</button>
</mat-dialog-actions>
<br>
<mat-dialog-content>
  <div width=100% height="700px;">
      
      <iframe [src]="receiptUrl" frameborder="0" width=100% height="600px;"></iframe>
  </div>
</mat-dialog-content>
      


